<template>
  <ul id="breadcrumb" class="no-mobile breadcrumb-tooltip">
    <li
      v-for="(bci, idx) in breadcrumb.bclist"
      :key="idx"
      @click="routeTo(idx)"
      :class="{ linked: !!bci.link }"
    >
      <h4 :class="{ tooltip: bci.tooltip }">
        {{ bci.name }}

        <span v-if="bci.tooltip" class="tooltiptext">
          {{ bci.tooltip }}
          <br />
          <a v-if="bci.video" :href="bci.video" target="_blank" class="button small secondary">
            <!-- <i class="fab fa-youtube" style="display:inline"></i> -->
            Saiba Mais
          </a>
        </span>
      </h4>
      <i class="fas fa-angle-right"></i>
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Breadcrumb",
  data() {
    return {};
  },
  mounted() {
    this.updateList();
  },
  watch: {
    "$route.name": function() {
      this.updateList();
    }
  },
  computed: {
    ...mapState({
      breadcrumb: state => state.breadcrumb
    })
  },
  methods: {
    routeTo(routeIdx) {
      let params = {};
      if (this.breadcrumb.bclist[routeIdx].params) params = this.breadcrumb.bclist[routeIdx].params;
      if (this.breadcrumb.bclist[routeIdx].link) {
        this.$router.push(
          Object.assign({ name: this.breadcrumb.bclist[routeIdx].link }, { params })
        );
      }
    },
    updateList() {
      this.$store.dispatch("setBreadcrumb", {
        breadcrumb: this.$route.meta.breadcrumb
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>